import { render, staticRenderFns } from "./BasicBillingInformation.vue?vue&type=template&id=5dc87b4e&scoped=true&"
import script from "./BasicBillingInformation.vue?vue&type=script&lang=ts&"
export * from "./BasicBillingInformation.vue?vue&type=script&lang=ts&"
import style0 from "./BasicBillingInformation.vue?vue&type=style&index=0&id=5dc87b4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc87b4e",
  null
  
)

export default component.exports